// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const FIREWORKS_MODELS = {
	"accounts/fireworks/models/deepseek-v4-flash": {
		id: "accounts/fireworks/models/deepseek-v4-flash",
		name: "DeepSeek V4 Flash",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.028,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/deepseek-v4-pro": {
		id: "accounts/fireworks/models/deepseek-v4-pro",
		name: "DeepSeek V4 Pro",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.74,
			output: 3.48,
			cacheRead: 0.145,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/glm-5p1": {
		id: "accounts/fireworks/models/glm-5p1",
		name: "GLM 5.1",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 202800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/glm-5p2": {
		id: "accounts/fireworks/models/glm-5p2",
		name: "GLM 5.2",
		api: "openai-completions",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false},
		reasoning: true,
		thinkingLevelMap: {"off":"none","minimal":null,"low":"high","medium":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.14,
			cacheWrite: 0,
		},
		contextWindow: 1048575,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"accounts/fireworks/models/gpt-oss-120b": {
		id: "accounts/fireworks/models/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.015,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/gpt-oss-20b": {
		id: "accounts/fireworks/models/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.3,
			cacheRead: 0.035,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/kimi-k2p6": {
		id: "accounts/fireworks/models/kimi-k2p6",
		name: "Kimi K2.6",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/kimi-k2p7-code": {
		id: "accounts/fireworks/models/kimi-k2p7-code",
		name: "Kimi K2.7 Code",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/minimax-m2p7": {
		id: "accounts/fireworks/models/minimax-m2p7",
		name: "MiniMax-M2.7",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 196608,
		maxTokens: 196608,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/minimax-m3": {
		id: "accounts/fireworks/models/minimax-m3",
		name: "MiniMax-M3",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 512000,
		maxTokens: 512000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/models/qwen3p7-plus": {
		id: "accounts/fireworks/models/qwen3p7-plus",
		name: "Qwen 3.7 Plus",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0.08,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/routers/glm-5p1-fast": {
		id: "accounts/fireworks/routers/glm-5p1-fast",
		name: "GLM 5.1 Fast",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 2.8,
			output: 8.8,
			cacheRead: 0.52,
			cacheWrite: 0,
		},
		contextWindow: 202800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/routers/glm-5p2-fast": {
		id: "accounts/fireworks/routers/glm-5p2-fast",
		name: "GLM 5.2 Fast",
		api: "openai-completions",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false},
		reasoning: true,
		thinkingLevelMap: {"off":"none","minimal":null,"low":"high","medium":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 2.1,
			output: 6.6,
			cacheRead: 0.21,
			cacheWrite: 0,
		},
		contextWindow: 1048575,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"accounts/fireworks/routers/kimi-k2p6-fast": {
		id: "accounts/fireworks/routers/kimi-k2p6-fast",
		name: "Kimi K2.6 Fast",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/routers/kimi-k2p6-turbo": {
		id: "accounts/fireworks/routers/kimi-k2p6-turbo",
		name: "Kimi K2.6 Turbo",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
	"accounts/fireworks/routers/kimi-k2p7-code-fast": {
		id: "accounts/fireworks/routers/kimi-k2p7-code-fast",
		name: "Kimi K2.7 Code Fast",
		api: "anthropic-messages",
		provider: "fireworks",
		baseUrl: "https://api.fireworks.ai/inference",
		compat: {"sendSessionAffinityHeaders":true,"supportsEagerToolInputStreaming":false,"supportsCacheControlOnTools":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.9,
			output: 8,
			cacheRead: 0.38,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
} as const;
